import {
  Box,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Grid,
  Icon,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'
import clsx from 'clsx'
import { connect } from 'react-redux'
import withReducer from 'app/store/withReducer'
import RoleAction from 'app/stores/loadz/redux/Roles/actions'
import RoleReducer from 'app/stores/loadz/redux/Roles'
import { useEffect, useRef, useState } from 'react'
import TableHeader from './TableHeader'
import { motion } from 'framer-motion'
import EmptyTableMessage from 'app/main/loadz/components/EmptyTableMessage'
import RolesHeader from './RolesHeader'
import { useHistory } from 'react-router-dom'
const Roles = ({ roles, getRoles, hasNextPage, page, loading }) => {
  const listInnerRef = useRef()
  const [scrollX, setScrollX] = useState(0)
  const history = useHistory()
  useEffect(async () => {
    await fetchRoles()
  }, [])

  const onScroll = async (event) => {
    if (listInnerRef.current) {
      const {
        scrollTop,
        scrollHeight,
        clientHeight,
        scrollLeft,
        offsetHeight,
      } = listInnerRef.current
      const allow = scrollLeft > scrollX || scrollLeft < scrollX ? false : true
      setScrollX(scrollLeft)
      if (offsetHeight + scrollTop >= scrollHeight && allow) {
        if (hasNextPage) {
          await fetchRoles(page + 1)
        }
      }
    }
  }

  const fetchRoles = async (page) => {
    await getRoles({ page }, (error) => {
      console.log(error)
    })
  }

  if (roles.length == 0) {
    return <EmptyTableMessage data="Roles" />
  }

  return (
    <div
      className={clsx('flex flex-1 flex-col m-16 p-24 mobile-p newjobdesign')}
    >
      <Box sx={{ width: '100%' }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <RolesHeader />
          <Grid item xs={10} className="grid-full">
            <Card className="jobtablecard">
              <CardContent className="jobstable">
                <div className="responsive-loads-table">
                  <TableContainer
                    style={{ maxWidth: '100%', maxHeight: '700px' }}
                    onScroll={onScroll}
                    ref={listInnerRef}
                  >
                    <Table
                      stickyHeader
                      size="small"
                      aria-labelledby="tableTitle"
                      className="pb-32"
                    >
                      <TableHeader />
                      <TableBody>
                        {roles.map((role, index) => (
                          <TableRow
                            className="h-72 cursor-pointer"
                            key={index}
                            onClick={() => history.push(`/roles/123`)}
                          >
                            <TableCell
                              className="w-40 md:w-64 text-center"
                              padding="none"
                            >
                              <Checkbox />
                            </TableCell>
                            <TableCell className="w-40 md:w-64 text-center">
                              {index + 1}
                            </TableCell>
                            <TableCell className="w-40 md:w-64 text-center">
                              {role.displayName}
                            </TableCell>
                            <TableCell className="w-40 md:w-64 text-center">
                              {role.name}
                            </TableCell>
                            <TableCell className="w-40 md:w-64 text-center">
                              {role.created_at ? role.created_at : '-'}
                            </TableCell>
                            <TableCell className="w-40 md:w-64 text-center">
                              {role.updated_at ? role.updated_at : '-'}
                            </TableCell>
                            <TableCell className="w-40 md:w-64 text-center">
                              <Chip
                                onClick={(event) => {}}
                                className="p-0 cursor-pointer bg-none"
                                label=""
                                icon={
                                  <Icon style={{ color: '#000' }}>
                                    edit <b>{role.id}</b>
                                  </Icon>
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {loading && <LinearProgress />}
                    {!hasNextPage ? (
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { delay: 0.1 } }}
                        className="flex flex-1 items-center justify-center h-full moble-content pb-16"
                      >
                        <Typography color="textSecondary" variant="h5">
                          No more Data
                        </Typography>
                      </motion.div>
                    ) : null}
                  </TableContainer>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    roles: state.loadz_roles?.RoleReducer?.roles,
    hasNextPage: state.loadz_roles?.RoleReducer?.hasNextPage,
    loading: state.loadz_roles?.RoleReducer?.loading,
    page: state.loadz_roles?.RoleReducer?.page,
  }
}

const mapDispatchToProps = (dispatch) => ({
  getRoles: (payload, onError) =>
    dispatch(RoleAction.getRoles(payload, onError)),
})

export default withReducer(
  'loadz_roles',
  RoleReducer
)(connect(mapStateToProps, mapDispatchToProps)(Roles))
